module.exports = __webpack_public_path__ + "static/media/vials.01aad665.svg";